import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const id = (store, key) => {
  let v = store.getItem(key);
  if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); store.setItem(key, v); }
  return v;
};

const send = (event, path) => {
  const body = { visitor_id: id(localStorage, "wm_vid"), session_id: id(sessionStorage, "wm_sid"), event, path, referrer: document.referrer || "" };
  api.post("/track", body).catch(() => {});
};

export const useTracking = () => {
  const { pathname } = useLocation();
  const skip = pathname.startsWith("/admin") || pathname.startsWith("/staff");
  useEffect(() => { if (!skip) send("pageview", pathname); }, [pathname, skip]);
  useEffect(() => {
    if (skip) return undefined;
    const t = setInterval(() => document.visibilityState === "visible" && send("heartbeat", pathname), 30000);
    return () => clearInterval(t);
  }, [pathname, skip]);
};
